module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "care container"
  }, [_c('el-col', {
    staticClass: "tip",
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "iconfont icon-tuikuan"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("无效退款")]), _vm._v(" "), _c('p', {
    staticClass: "remark"
  }, [_vm._v("优化无效全额退款")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tip",
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "iconfont icon-sheji"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("赠送网站")]), _vm._v(" "), _c('p', {
    staticClass: "remark"
  }, [_vm._v("海量模板任意挑选")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tip",
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "iconfont icon-qiye"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("老牌企业")]), _vm._v(" "), _c('p', {
    staticClass: "remark"
  }, [_vm._v("10年经验实力有保障")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tip",
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wangzhan"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("专业服务器")]), _vm._v(" "), _c('p', {
    staticClass: "remark"
  }, [_vm._v("独立服务器稳定高效")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-000f5703!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/care.vue
// module id = 179
// module chunks = 2